export default "__VITE_ASSET__Btq0ik6L__"